import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";

@CwtModel({ name: 'creditor' })
@CwtCrudContract({ path: 'creditor' })
export class Creditor extends CwtApiEntity {
    @CwtProp() name: string;
}